import * as React from "react";
import {cx} from "emotion";

import "./breadcrumbs2.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const Breadcrumbs2 = ({className=undefined, style=undefined, steps}) => cs(
    ["hover", (_, next) => UseState({next})],
    ({hover}) => (
        <div className={cx("breadcrumbs breadcrumbs-582", className)}>
            {steps.map(({active, disabled, label, onSelect}, i) => {
                const hovered = hover.value === i;
                const arrowLeft = i > 0;
                const arrowRight = i < steps.length - 1;

                const fill = (
                    active ? (
                        hovered ? (
                            "#29e271"
                        ) : (
                            "#16D761"
                        )
                    ) : disabled ? (
                        "#ebebeb"
                    ) : hovered ? (
                        "#e3e4e5"
                    ) : (
                        "#F5F6F8"
                    )
                );

                return (
                    <div
                        className={cx(
                            "step",{active, disabled, hovered, arrowLeft, arrowRight},
                        )}
                        key={i}
                        onClick={() => !active && !disabled && onSelect()}
                        style={{
                            background: fill,
                            ...style?.stepMinWidth && {
                                minWidth: style.stepMinWidth,
                            },
                        }}
                        onMouseEnter={() => hover.onChange(i)}
                        onMouseLeave={() => hover.onChange(null)}
                        xd-qa-type="link"
                        xd-qa-name={label}
                    >
                        {arrowLeft && (
                            ArrowLeft({fill})
                        )}
                        {arrowRight && (
                            ArrowRight({fill})
                        )}

                        <div className="label">
                            {label}
                        </div>
                    </div>
                );
            })}
        </div>
    ),
);

const ArrowLeft = ({fill}) => cs(
    ({}) => {
        const w = 43;
        const h = 100;
        return (
            <svg className="arrow-left" viewBox={`0 0 ${w} ${h}`}>
                <path
                    d={`M0,0 ${w + 10},0 ${w + 10},${h} 0,${h} ${w},${h / 2} Z`}
                    fill={fill}
                />
            </svg>
        );
    },
);
const ArrowRight = ({fill}) => cs(
    ({}) => {
        const w = 43;
        const h = 100;
        return (
            <svg className="arrow-right" viewBox={`0 0 ${w} ${h}`}>
                <path
                    d={`M-10,0 0,0 ${w},${h/2} 0,${h} -10,${h} Z`}
                    fill={fill}
                />
            </svg>
        );
    },
);